
import piProducerAdd from "./components/pi-add-producer.vue";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { getManufacturerPage, delManufacturer } from "@/api/api-basic";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    piSelectOper,
    "pi-add-producer": piProducerAdd
  }
})
export default class PiProducer extends Vue {
  private privilegeVoObj: objAny = {};

  private formInline: objAny = {
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: "",
    oprPkId: ""
  };
  private total = 0;
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("producer.busLicenseNumber"),
      key: "busLicenseNumber",
      minWidth: 160
    },
    {
      title: i18n.t("producer.brandName"),
      key: "brandName",
      minWidth: 160
    },
    {
      title: i18n.t("producer.manufacturerName"),
      key: "manufacturerName",
      minWidth: 160
    },
    {
      title: i18n.t("producer.manufacturerId"),
      key: "manufacturerId",
      minWidth: 160
    },
    // {
    //   title: "设备厂商主键",
    //   key: "manufacturerPkId",
    //   minWidth: 160
    // },
    {
      title: i18n.t("producer.contactName"),
      key: "contactName",
      minWidth: 160
    },
    {
      title: i18n.t("producer.phoneNo"),
      key: "phoneNo",
      minWidth: 110
    },
    {
      title: i18n.t("producer.legalPerson"),
      key: "legalPerson",
      minWidth: 160
    },
    {
      title: i18n.t("producer.legalIdCard"),
      key: "legalIdCard",
      minWidth: 160
    },
    {
      title: i18n.t("operation"),
      slot: "action",
      minWidth: 180,
      align: "center"
    }
  ];
  public operChange(val: number | string) {
    this.formInline.oprPkId = val;
  }
  public tableChange(val: number) {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public tableSizeChange(val: number) {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  async getTableList(): Promise<void> {
    const ret = await getManufacturerPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.tableList = ret.data;
      this.total = ret.total;
    }
  }
  public searchClick() {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public addClick() {
    const piProducerAdd: objAny = this.$refs["piProducerAdd"];
    piProducerAdd.open();
  }
  public editClick(item: objAny) {
    const piProducerAdd: objAny = this.$refs["piProducerAdd"];
    piProducerAdd.open(item);
  }
  async delItemClick(item: objAny): Promise<void> {
    const ret = await delManufacturer({
      manufacturerPkId: item.manufacturerPkId
    });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("deleteSuccess"));
      this.getTableList();
    }
  }

  mounted() {
    this.getTableList();
    this.privilegeVoObj = this.$route.meta.privilegeVoObj;
  }
}
